module.exports = __webpack_public_path__ + "static/img/samajuri (28).e51cdab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (28).jpg
// module id = S8es
// module chunks = 0